<template>
  <AlertPopup
    :visible="alertState.visible"
    :type="alertState.type"
    :title="alertState.title"
    :message="alertState.message"
    :button-text="alertState.buttonText"
    :allow-backdrop-close="alertState.allowBackdropClose"
    @confirm="handleAlertConfirm"
    @close="handleAlertClose"
  />
  <ConfirmPopup
    :visible="confirmState.visible"
    :type="confirmState.type"
    :title="confirmState.title"
    :message="confirmState.message"
    :confirm-text="confirmState.confirmText"
    :cancel-text="confirmState.cancelText"
    :confirm-variant="confirmState.confirmVariant"
    :allow-backdrop-close="confirmState.allowBackdropClose"
    @confirm="handleConfirmConfirm"
    @cancel="handleConfirmCancel"
    @close="handleConfirmClose"
  />
</template>

<script setup>
import { usePopup } from '@/shared/composables/usePopup';
import AlertPopup from './AlertPopup.vue';
import ConfirmPopup from './ConfirmPopup.vue';

const { alertState, confirmState, closeAlert, closeConfirm } = usePopup();

const handleAlertConfirm = () => {
  closeAlert();
};

const handleAlertClose = () => {
  closeAlert();
};

const handleConfirmConfirm = () => {
  closeConfirm(true);
};

const handleConfirmCancel = () => {
  closeConfirm(false);
};

const handleConfirmClose = () => {
  closeConfirm(false);
};
</script>

